import { useAsyncEffect } from '@xylabs/sdk-react'
import numeral from 'numeral'
import { useContext, useState } from 'react'

import { EntityContext } from '../../Contexts'
import { Property } from '../Property'

const LandAreaProperty: React.FC = () => {
  const entity = useContext(EntityContext)
  const [landArea, setLandArea] = useState<number>()

  useAsyncEffect(
    // eslint-disable-next-line react-hooks/exhaustive-deps
    async (isMounted) => {
      const landArea = await entity?.getGeotokenList()?.getLandArea()
      if (isMounted()) {
        setLandArea(landArea)
      }
    },
    [entity],
  )

  return <Property title="Land Area" value={landArea ? `${numeral(landArea).format('0.0a')} Units` : null} />
}

export default LandAreaProperty
